/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} FridayInputs */

const en_friday = /** @type {(inputs: FridayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Friday`)
};

const de_friday = /** @type {(inputs: FridayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Freitag`)
};

/**
* | output |
* | --- |
* | "Friday" |
*
* @param {FridayInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const friday = /** @type {((inputs?: FridayInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<FridayInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_friday(inputs)
	return de_friday(inputs)
});